import {openProductPopupHandler} from "./productPopup";

//const stockMessage = document.querySelector('.js-popup-stock');
const stockMessages = [...document.querySelectorAll('.js-popup-stock-trigger')];

if(stockMessages) {
    stockMessages.map(stockMessage => {
        stockMessage.addEventListener('click', (e) => {
            e.preventDefault();
            openProductPopupHandler('product-stock', e.srcElement.dataset.title);
        });
    });
}
